// Admin Panel Component - Styled Version
import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import adminInstance from '../../../instance/AdminInstance';

const NotificationForm = () => {
    const Navigate = useNavigate();
    const [notification, setNotification] = useState("");
    const [title, setTitle] = useState("");
    const [error, setError] = useState("");
    const [sendingTo, setSendingTo] = useState("all");

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (notification !== "") {
            try {
                const payload = {
                    notification: notification,
                    title: title || notification,
                    broadcast: true,
                    type: 'admin_broadcast'
                };

                const response = await adminInstance.post(
                    '/api/super_admin/notification_control/sent_notification', 
                    payload
                );

                toast.success('Notification sent successfully to all users!');
                Navigate('/admin/notifications');
                
            } catch (error) {
                console.error('Error sending notification:', error);
                toast.error('Something went wrong');
            }
            setError("");
        } else {
            setError("Notification message is required");
        }
    };

    return (
        <div style={styles.container}>
            <div style={styles.card}>
                <div style={styles.header}>
                    <h2 style={styles.headerTitle}>📢 Send Notification</h2>
                    <p style={styles.headerSubtitle}>Broadcast a message to your users</p>
                </div>

                <form onSubmit={handleSubmit} style={styles.form}>
                    {/* Title Field */}
                    <div style={styles.formGroup}>
                        <label style={styles.label}>
                            Title <span style={styles.optional}>(Optional)</span>
                        </label>
                        <input
                            type="text"
                            placeholder="e.g., Important Update, Flash Sale Alert"
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                            style={styles.input}
                        />
                        <small style={styles.helpText}>
                            If left empty, the message will be used as title
                        </small>
                    </div>

                    {/* Message Field */}
                    <div style={styles.formGroup}>
                        <label style={styles.label}>
                            Message <span style={styles.required}>*</span>
                        </label>
                        <textarea
                            placeholder="Enter your notification message..."
                            value={notification}
                            onChange={(e) => setNotification(e.target.value)}
                            style={styles.textarea}
                            rows="5"
                            required
                        />
                    </div>

                    {/* Platform Selection */}
                    <div style={styles.formGroup}>
                        <label style={styles.label}>Send To</label>
                        <div style={styles.radioGroup}>
                            <label style={styles.radioLabel}>
                                <input
                                    type="radio"
                                    value="all"
                                    checked={sendingTo === 'all'}
                                    onChange={(e) => setSendingTo(e.target.value)}
                                    style={styles.radioInput}
                                />
                                <span style={styles.radioText}>
                                    <span style={styles.radioIcon}>🌐</span>
                                    All Users (Web + Mobile)
                                </span>
                            </label>
                            <label style={styles.radioLabel}>
                                <input
                                    type="radio"
                                    value="web"
                                    checked={sendingTo === 'web'}
                                    onChange={(e) => setSendingTo(e.target.value)}
                                    style={styles.radioInput}
                                />
                                <span style={styles.radioText}>
                                    <span style={styles.radioIcon}>💻</span>
                                    Web Only
                                </span>
                            </label>
                            <label style={styles.radioLabel}>
                                <input
                                    type="radio"
                                    value="mobile"
                                    checked={sendingTo === 'mobile'}
                                    onChange={(e) => setSendingTo(e.target.value)}
                                    style={styles.radioInput}
                                />
                                <span style={styles.radioText}>
                                    <span style={styles.radioIcon}>📱</span>
                                    Mobile Only
                                </span>
                            </label>
                        </div>
                    </div>

                    {error && (
                        <div style={styles.errorMessage}>
                            <span style={styles.errorIcon}>⚠️</span>
                            {error}
                        </div>
                    )}

                    <div style={styles.formActions}>
                        <button type="submit" style={styles.btnPrimary}>
                            <span style={styles.btnIcon}>📤</span>
                            Send Notification
                        </button>
                        <button 
                            type="button" 
                            style={styles.btnSecondary}
                            onClick={() => Navigate('/admin/notifications')}
                        >
                            Cancel
                        </button>
                    </div>
                </form>

                {/* Preview */}
                {(title || notification) && (
                    <div style={styles.previewSection}>
                        <h4 style={styles.previewTitle}>📱 Preview</h4>
                        <div style={styles.previewBox}>
                            <div style={styles.previewHeader}>
                                <div style={styles.previewIcon}>🔔</div>
                                <div style={styles.previewContent}>
                                    <strong style={styles.previewTitleText}>
                                        {title || notification.substring(0, 30) || 'Notification Title'}
                                    </strong>
                                    <p style={styles.previewMessage}>
                                        {notification || 'Your notification message will appear here...'}
                                    </p>
                                    <span style={styles.previewTime}>Just now</span>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

const styles = {
    container: {
        minHeight: '100vh',
        backgroundColor: '#f5f7fa',
        padding: '24px',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    },
    card: {
        maxWidth: '800px',
        margin: '0 auto',
        backgroundColor: '#ffffff',
        borderRadius: '12px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
        overflow: 'hidden',
    },
    header: {
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        padding: '32px',
        color: '#ffffff',
    },
    headerTitle: {
        margin: '0 0 8px 0',
        fontSize: '28px',
        fontWeight: '700',
        letterSpacing: '-0.5px',
    },
    headerSubtitle: {
        margin: 0,
        fontSize: '15px',
        opacity: 0.9,
    },
    form: {
        padding: '32px',
    },
    formGroup: {
        marginBottom: '28px',
    },
    label: {
        display: 'block',
        marginBottom: '8px',
        fontSize: '14px',
        fontWeight: '600',
        color: '#2d3748',
    },
    optional: {
        fontSize: '13px',
        fontWeight: '400',
        color: '#718096',
    },
    required: {
        color: '#e53e3e',
        fontWeight: '700',
    },
    input: {
        width: '100%',
        padding: '12px 16px',
        fontSize: '15px',
        border: '2px solid #e2e8f0',
        borderRadius: '8px',
        outline: 'none',
        transition: 'all 0.2s',
        backgroundColor: '#ffffff',
        boxSizing: 'border-box',
    },
    textarea: {
        width: '100%',
        padding: '12px 16px',
        fontSize: '15px',
        border: '2px solid #e2e8f0',
        borderRadius: '8px',
        outline: 'none',
        transition: 'all 0.2s',
        backgroundColor: '#ffffff',
        fontFamily: 'inherit',
        resize: 'vertical',
        boxSizing: 'border-box',
    },
    helpText: {
        display: 'block',
        marginTop: '6px',
        fontSize: '13px',
        color: '#718096',
    },
    radioGroup: {
        display: 'flex',
        gap: '12px',
        flexWrap: 'wrap',
    },
    radioLabel: {
        flex: '1',
        minWidth: '180px',
        padding: '16px',
        border: '2px solid #e2e8f0',
        borderRadius: '8px',
        cursor: 'pointer',
        transition: 'all 0.2s',
        backgroundColor: '#ffffff',
        display: 'flex',
        alignItems: 'center',
    },
    radioInput: {
        marginRight: '12px',
        cursor: 'pointer',
        width: '18px',
        height: '18px',
    },
    radioText: {
        fontSize: '14px',
        fontWeight: '500',
        color: '#2d3748',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
    },
    radioIcon: {
        fontSize: '20px',
    },
    errorMessage: {
        padding: '12px 16px',
        backgroundColor: '#fff5f5',
        border: '1px solid #feb2b2',
        borderRadius: '8px',
        color: '#c53030',
        fontSize: '14px',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        marginBottom: '20px',
    },
    errorIcon: {
        fontSize: '18px',
    },
    formActions: {
        display: 'flex',
        gap: '12px',
        marginTop: '32px',
    },
    btnPrimary: {
        flex: 1,
        padding: '14px 24px',
        fontSize: '15px',
        fontWeight: '600',
        color: '#ffffff',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        border: 'none',
        borderRadius: '8px',
        cursor: 'pointer',
        transition: 'all 0.2s',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
    },
    btnSecondary: {
        padding: '14px 24px',
        fontSize: '15px',
        fontWeight: '600',
        color: '#4a5568',
        backgroundColor: '#ffffff',
        border: '2px solid #e2e8f0',
        borderRadius: '8px',
        cursor: 'pointer',
        transition: 'all 0.2s',
    },
    btnIcon: {
        fontSize: '18px',
    },
    previewSection: {
        padding: '32px',
        backgroundColor: '#f7fafc',
        borderTop: '1px solid #e2e8f0',
    },
    previewTitle: {
        margin: '0 0 16px 0',
        fontSize: '16px',
        fontWeight: '700',
        color: '#2d3748',
    },
    previewBox: {
        backgroundColor: '#ffffff',
        border: '1px solid #e2e8f0',
        borderRadius: '8px',
        padding: '16px',
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
    },
    previewHeader: {
        display: 'flex',
        gap: '12px',
    },
    previewIcon: {
        width: '48px',
        height: '48px',
        backgroundColor: '#e6f2ff',
        borderRadius: '12px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '24px',
        flexShrink: 0,
    },
    previewContent: {
        flex: 1,
    },
    previewTitleText: {
        display: 'block',
        fontSize: '15px',
        fontWeight: '700',
        color: '#1a202c',
        marginBottom: '4px',
    },
    previewMessage: {
        margin: '0 0 6px 0',
        fontSize: '14px',
        color: '#4a5568',
        lineHeight: '1.5',
    },
    previewTime: {
        fontSize: '12px',
        color: '#a0aec0',
    },
};

export default NotificationForm;